import { Math as MathUtil, Vector3 } from "three";
import { TWO_PI } from "./math";

export default class AmbientMotion {
  constructor(gui) {
    // this.gui = gui.addFolder("ambient motion");
    // this.gui.open();
    this.time = 0;
    this.value = new Vector3();
    this.phase = new Vector3(
      MathUtil.randFloat(0, TWO_PI),
      MathUtil.randFloat(0, TWO_PI),
      MathUtil.randFloat(0, TWO_PI)
    );
    const radius = 0.5;
    const speed = 1;
    this.radius = new Vector3(radius, radius, radius);
    this.speed = new Vector3(speed, speed, speed);

    // this.gui.add(this.radius, "x", 0, 1).name("radius x");
    // this.gui.add(this.radius, "y", 0, 1).name("radius y");
    // this.gui.add(this.radius, "z", 0, 1).name("radius y");
    // this.gui.add(this.speed, "x", 0, 5).name("speed x");
    // this.gui.add(this.speed, "y", 0, 5).name("speed y");
    // this.gui.add(this.speed, "z", 0, 5).name("speed z");
  }

  update(delta) {
    this.time += delta;
    this.value.x =
      Math.cos(this.phase.x + this.time * this.speed.x) * this.radius.x;
    this.value.y =
      Math.sin(this.phase.y + this.time * this.speed.y) * this.radius.y;
    this.value.z =
      Math.sin(this.phase.z + this.time * this.speed.z) * this.radius.z;
  }
}
